import { user } from './user'
import { goods } from './goods'

export const api = {
  user,
  goods,
}
